import {
  getAllQueryParams,
  reloadPage,
} from '../services/window-location-service';
import { scrollToElement } from '../services/window-service';
import { NakedFormSelect } from '../components/naked-form-select';

export class ClinicalTrialsLanding extends DrupalBehavior {
  onContent(context) {
    const form = once(
      'clinical-trials-form',
      '.clinical-trials-filter-form',
      context
    );

    form.forEach(() => {
      new NakedFormSelect({
        formElement: context,
        target: 'select#edit-area',
        placeholder: 'Search specialties',
        customMultiSelectedTextOptions: {
          customMultiText: 'specialties selected',
          enableNumberToken: true,
        },
      }).setUpNakedFormSelectDropdown({
        headerText: 'Specialties',
      });

      if (getAllQueryParams().size > 0) {
        this.scrollToResults(context);
      }
    });
  }

  scrollToResults(context) {
    gsap.registerPlugin(ScrollToPlugin);
    scrollToElement(context, '.clinical-trials--results');
  }
}

DrupalBehavior.register(
  'rush_theme.pages',
  'clinical_trials_landing',
  ClinicalTrialsLanding
);
